import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ScrollSpy from '../../../layouts/scrollspy';
import ListingBadge, { BADGE_MODE } from './base';
import { isTPSLive, isTPSOnline, isFCLMarketing, hasADCAuctioneer, } from './utils';
class ConductedByADCOnlineBadge extends ListingBadge {
    static title = 'Conducted by Auction.com';
    static titleIcon = 'gavel';
    static shouldBeIncluded(listing, badgeMode) {
        return badgeMode === BADGE_MODE.EXPANDED && isTPSOnline(listing);
    }
    get content() {
        return (_jsxs(_Fragment, { children: ["This is an online auction conducted by Auction.com.", _jsx(ScrollSpy, { selector: '#faqs', children: ({ scrollTo }) => _jsx("a", { onClick: scrollTo, children: " Learn More." }) })] }));
    }
}
class ConductedByADCLiveBadge extends ConductedByADCOnlineBadge {
    static shouldBeIncluded(listing, badgeMode) {
        return (badgeMode === BADGE_MODE.EXPANDED &&
            isTPSLive(listing) &&
            hasADCAuctioneer(listing));
    }
    get content() {
        return (_jsxs(_Fragment, { children: ["Auction.com will conduct the sale in person.", ' ', _jsx("a", { href: 'https://auction.onelink.me/WqvL/7185fc99', target: '_blank', rel: 'noreferrer', children: "Download the app" }), ' ', "for real time updates and time-saving benefits."] }));
    }
}
class NotConductedByADCLive extends ConductedByADCOnlineBadge {
    static summary = 'No';
    static contentPositive = false;
    static shouldBeIncluded(listing, badgeMode) {
        return (badgeMode === BADGE_MODE.EXPANDED &&
            isTPSLive(listing) &&
            !hasADCAuctioneer(listing));
    }
    get content() {
        return (_jsxs(_Fragment, { children: ["This in-person auction will be conducted by a third party at a county location.", _jsx(ScrollSpy, { selector: '#prepare_your_finances', children: ({ scrollTo }) => _jsx("a", { onClick: scrollTo, children: " Learn More." }) })] }));
    }
}
class NotConductedByADCFCLBadge extends ConductedByADCOnlineBadge {
    static summary = 'No';
    static contentPositive = false;
    static shouldBeIncluded(listing, badgeMode) {
        return badgeMode === BADGE_MODE.EXPANDED && isFCLMarketing(listing);
    }
    get content() {
        return (_jsxs(_Fragment, { children: ["This is an online auction conducted by a third party at the county website.", ' ', _jsx("a", { onClick: e => this.emitEvent('bid_at_county_site', e), children: "Learn More" })] }));
    }
}
export { NotConductedByADCFCLBadge, ConductedByADCOnlineBadge, ConductedByADCLiveBadge, NotConductedByADCLive, };
//# sourceMappingURL=conductedByADC.js.map